<div class="d-flex flex-column">
  <!-- Top Bar -->
  <div
    *ngIf="!isMobile"
    class="global__top-bar d-flex align-items-center px-15px fs-18px font-weight-bold fc-default justify-content-between border-bottom border-color-grey"
  >
    <div class="d-flex align-items-center">
      <top-bar-mobile-navigation-control
        class="mr-15px d-lg-none d-inline-block"
      ></top-bar-mobile-navigation-control>
      Home
    </div>
  </div>

  <div class="global__top-bar__height"></div>
  <div *ngIf="!isMobile">
    <!-- Create Post -->
    <div class="border-bottom border-color-grey formbg">
      <feed-create-post
        [numberOfRowsInTextArea]="2"
        [postRefreshFunc]="prependPostToFeed.bind(this)"
      ></feed-create-post>
    </div>

    <!-- Light Grey Divider -->
    <div
      class="w-100 border-bottom border-color-grey light-grey-divider"
      style="min-height: 10px"
    ></div>
  </div>

  <!-- Mobile DeSo Price -->
  <div
    *ngIf="isMobile"
    class="d-flex border-bottom border-color-grey background-color-light-grey py-5px px-15px fs-12px"
  >
    <div>$DESO Price&nbsp;&nbsp;&nbsp;</div>
    <div>
      <span>~{{ globalVars.desoToUSDExchangeRateToDisplay }}</span>
      <span class="text-muted">&nbsp;USD per coin</span>
    </div>
  </div>

  <!-- Mobile email confirmation alert -->
  <div
    *ngIf="
      isMobile &&
      globalVars.loggedInUser &&
      !globalVars.loggedInUser.EmailVerified
    "
    class="d-flex border-bottom border-color-grey background-color-light-grey py-5px px-15px fs-12px"
  >
    <div>Your email is not verified.&nbsp;&nbsp;&nbsp;</div>
    <div>
      <div *ngIf="globalVars.loggedInUser.HasEmail">
        <a
          class="font-weight-bold"
          (click)="globalVars.resendVerifyEmail()"
          *ngIf="!globalVars.resentVerifyEmail"
          >Resend Verification Email</a
        >
        <span *ngIf="globalVars.resentVerifyEmail">Sent!</span>
      </div>
      <a
        *ngIf="!globalVars.loggedInUser.HasEmail"
        [routerLink]="'/' + globalVars.RouteNames.SETTINGS"
        class="font-weight-bold"
        >Update your email</a
      >
    </div>
  </div>

  <!-- Referral links alert -->
  <div
    *ngIf="globalVars.loggedInUser?.ReferralInfoResponses?.length > 0"
    class="d-flex border-bottom justify-content-center border-color-grey background-color-lemon-chiffon py-5px px-15px fs-12px"
  >
    <div style="color: #333333; text-align: center">
      You have a
      <b>{{
        globalVars.formatUSD(
          globalVars.loggedInUser.ReferralInfoResponses[0].Info
            .ReferrerAmountUSDCents / 100,
          0
        )
      }}</b>
      referral link on Diamond...<br /><a
        href="https://diamondapp.com"
        class="font-weight-bold"
        >Check it out!</a
      >
    </div>
  </div>
  <div
    *ngIf="!globalVars.loggedInUser?.ReferralInfoResponses?.length"
    class="d-flex border-bottom justify-content-center border-color-grey background-color-lemon-chiffon py-5px px-15px fs-12px"
  >
    <div style="color: #333333; text-align: center">
      Diamond is a cool new DeSo app...<br /><a
        href="https://diamondapp.com"
        class="font-weight-bold"
        >Check it out!</a
      >
    </div>
  </div>

  <!-- Tab Selector -->
  <tab-selector
    [tabs]="feedTabs"
    [activeTab]="activeTab"
    (tabClick)="_handleTabClick($event)"
  ></tab-selector>

  <countdown-timer
    *ngIf="nextNFTShowcaseTime"
    [timerText]="'The next NFT showcase drops in...'"
    [fontWeight]="500"
    [timerEnd]="nextNFTShowcaseTime"
  ></countdown-timer>

  <div [id]="getPullToRefreshMarkerId()"></div>

  <!-- Posts -->
  <div *ngIf="showGlobalOrFollowingPosts()">
    <div *ngFor="let post of postsToShow()">
      <div *ngIf="post.ProfileEntryResponse">
        <!--
            The post.parentPost stuff is a hack to make it so that a new comment shows up
            in the feed with the "replying to @[parentPost.Username]" content diplayed.
            post.parentPost is set in appendCommentAfterParentPost
          -->
        <feed-post
          *ngIf="!post.IsHidden"
          [post]="post"
          [includePaddingOnPost]="true"
          [afterCommentCreatedCallback]="
            appendCommentAfterParentPost.bind(this)
          "
          [afterRepostCreatedCallback]="prependPostToFeed.bind(this)"
          [showReplyingToContent]="!!post.parentPost"
          [parentPost]="post.parentPost"
          [contentShouldLinkToThread]="true"
          [showLeftSelectedBorder]="post.IsPinned"
          [blocked]="
            globalVars.hasUserBlockedCreator(post.PosterPublicKeyBase58Check)
          "
          [cardStyle]="true"
          [showNFTDetails]="true"
          (postDeleted)="onPostHidden($event)"
          (userBlocked)="userBlocked()"
        ></feed-post>
      </div>
    </div>

    <div
      *ngIf="showMoreButton()"
      class="w-100 py-15px d-flex align-items-center justify-content-center cursor-pointer creator-leaderboard__load-more"
      (click)="loadMorePosts()"
    >
      <div *ngIf="!activeTabReadyForDisplay()" class="fs-15px">Load More</div>
      <div *ngIf="activeTabReadyForDisplay()" class="fs-15px">Loading...</div>
    </div>
  </div>

  <div *ngIf="activeTab === FeedComponent.SHOWCASE_TAB">
    <nft-showcase></nft-showcase>
  </div>

  <div
    *ngIf="showNoPostsFound()"
    class="d-flex flex-column align-items-center justify-content-center fc-muted fs-15px p-15px text-center"
    style="height: 400px"
  >
    <div>No posts yet</div>

    <div class="mt-10px">
      <a
        class=""
        [routerLink]="['/' + globalVars.RouteNames.BROWSE]"
        [queryParams]="{ feedTab: FeedComponent.GLOBAL_TAB }"
        queryParamsHandling="merge"
      >
        View the global feed
      </a>
      to find more people to follow
    </div>
  </div>
  <simple-center-loader *ngIf="showLoadingSpinner()"></simple-center-loader>
  <!-- SPACER FOR BOTTOM BAR ON MOBILE -->
  <div class="global__bottom-bar-mobile-height"></div>
  <div class="global__bottom-bar-mobile-height"></div>
</div>
